import React from "react"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import { withStyles } from "@material-ui/core/styles"

const styles = theme => ({
	root: {
		padding: `${theme.spacing ( 2 )}px 0`,
		width: "100%",
		margin: `0 ${theme.spacing ( 2 )}px`
	},
	title: {
		fontWeight: 700,
		textTransform: "uppercase"
	}
})

class Type extends React.Component {

	render () {
		const { classes, theme, variant } = this.props
		return <div className={classes.root} >
			<Typography
				variant="body2"
				className={classes.title} >
				{variant}
			</Typography>
			<Typography variant={variant} >Sample Text</Typography>
		</div>
	}

}

Type.propTypes = {
	classes: PropTypes.object.isRequired,
	variant: PropTypes.string.isRequired
}

export default withStyles ( styles, { withTheme: true } ) ( Type )
